
export default {
  name: "BreadCrumb",
  data() {
    return {
      pages: [],
      items: []
    };
  },
  props: {
    lastItemName: String
  },
  watch: {
    lastItemName(newVal) {
      if (newVal) this.pages[this.pages.length - 1]["name"] = this.lastItemName;
    }
  },
  methods: {
    onClickPage(page) {
      this.$router.push(`/${page.path}`);
    }
  },
  mounted() {
    const { path } = this.$route;

    const pages = path.split("/").filter(p => p !== "");

    this.pages = pages.map((p, idx) => {
      return { name: p, path: pages.slice(0, idx + 1).join("/") };
    });

    // Remove parents breadcumb but maintain correct paths
    if (this.pages[0].name === "parents") {
      this.pages.splice(0, 1);
    }

    if (this.lastItemName) {
      this.pages[this.pages.length - 1]["name"] = this.lastItemName;
    }
  }
};
